// extracted by mini-css-extract-plugin
module.exports = {"form":"ProductForm_form__1ljek"};